import 'twin.macro';
import React from 'react';
import {
  buildConfig,
  computeNodes,
} from '@teetsh/app/src/containers/Sequences/List/Sidebar/utils';
import { Navigation } from '@teetsh/app/src/containers/Sequences/List/Sidebar/Navigation';
import useSequencesFolders from '@teetsh/app/src/queries/sequences/useSequencesFolders';
import { findFolderNodeWithAncestors } from 'containers/Sequences/findFolderNodeWithAncestors';
import { getRandomInt } from 'utils/getRandomInt';
import { MIN_NB_OF_SEQUENCES_TO_SHOW_FOLDER_TIP } from 'containers/Sequences/constants';
import { FolderTip } from './FolderTip';
import { useTranslation } from 'react-i18next';
import { FolderType } from 'types/sequences';

interface Props {
  elementId?: string;
  hideActions?: boolean;
  changeOrderFdp?: (
    index: number,
    direction: -1 | 1,
    items: string[],
    sequenceId: string,
  ) => any;
  onClickFicheDePrep?: (ficheDePrepId: string, sequenceId?: string) => void;
  onClickSequence?: (
    sequenceId: string,
    sequenceName: string,
    parents: string[],
  ) => void;
  onClickFolder?: (
    folderId: string,
    folderName: string,
    parents: string[],
  ) => void;
  visibleTypes: FolderType[];
  previewFdp?: boolean;
  showAddFdpButton?: boolean;
  showFolderTip?: boolean;
  hiddenActions?: 'all';
}

export function SequencesTree(props: Props) {
  const {
    elementId,
    changeOrderFdp,
    onClickFicheDePrep,
    onClickSequence,
    onClickFolder,
    visibleTypes,
    previewFdp = false,
    showAddFdpButton = false,
    hideActions = false,
    showFolderTip = false,
    hiddenActions,
  } = props;
  const { data: nodes = [], isLoading } = useSequencesFolders();
  const hasRootFolder = nodes.some(f => f.type === 'folder');
  const { t } = useTranslation(['sequence']);
  const matchingChildren = elementId
    ? findFolderNodeWithAncestors(nodes, elementId)
    : {
        ancestors: [],
      };

  if (isLoading) {
    return (
      <div tw="space-y-3 mt-3">
        {Array.from({ length: getRandomInt(6) + 2 }, (_, i) => (
          <li key={i} className="tsh-skeleton" tw="h-10 rounded-lg list-none" />
        ))}
      </div>
    );
  }
  return (
    <>
      <Navigation
        onClickFicheDePrep={onClickFicheDePrep}
        onClickSequence={onClickSequence}
        onClickFolder={onClickFolder}
        path={[
          ...(matchingChildren?.ancestors || [])?.map(a => a.id),
          ...(elementId ? [elementId] : []),
        ]}
        nodes={computeNodes({
          selectedItemId: elementId,
          visibleTypes,
          hideActions,
          changeOrderFdp,
          onAddFdp: onClickFicheDePrep,
          folders: nodes,
          previewFdp,
          showAddFdpButton,
          hiddenActions,
          config: buildConfig(t),
        })}
      />
      {showFolderTip &&
        !hasRootFolder &&
        nodes.length > MIN_NB_OF_SEQUENCES_TO_SHOW_FOLDER_TIP && <FolderTip />}
    </>
  );
}
